import {useContext, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {dateToHumanDateStr, display24HourTime} from "../../shared/date.js";
import {Box, Button, Paper, Skeleton, Typography} from "@mui/material";
import {Crumbs} from "../Crumbs.jsx";
import {DanceEventContext} from "../DanceEventProvider.jsx";
import Link from "@mui/material/Link";
import VenueMeta from "../VenueMeta.jsx";
import {InTownURI} from "../Button/InTownButton.jsx";
import {OutOfTownURI} from "../Button/OutOfTownButton.jsx";
import {Venue} from "../../shared/type/venue.ts";
import PublicIcon from "@mui/icons-material/Public.js";
import InstagramIcon from "@mui/icons-material/Instagram.js";
import {toSlots} from "../../shared/class/event.ts";
import TipBox from "../TipBox.jsx";

const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];

const VenuePage = () => {
    const [venue, setVenue] = useState(null);
    const params = useParams();
    const venueKey = params.venueKey
    const deContext = useContext(DanceEventContext);
    const [loading, setLoading] = useState(true);

    const events = loading ? [] : deContext.events.filter(e => e.venue.venueKey === venue.venueKey);


    useEffect(() => {
        // Fetch venue from Strapi by documentId
        fetch(`${BACKEND_HOST}/venues?filters[venueKey][$eq]=` + venueKey + `&populate=images`, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then(res => res.json())
            .then(res => {
                if (res.data.length > 0) {
                    // Populate all fields from Strapi response using object spread
                    setVenue(new Venue(res.data[0]))
                }

            })
            .finally(() => setTimeout(() => setLoading(false), 100));
    }, []);

    let crumbs = [
        {title: "Where To Dance", href: "/where-to-dance"}
    ]
    if (venue) {
        crumbs.push({
            title: venue.market === 'local' ? "In & Near Town" : "Out of Town",
            href: venue.market === 'local' ? InTownURI : OutOfTownURI
        })
        crumbs.push({
            title: venue.name
        })
    } else {
        crumbs.push({
            title: loading ? "Loading" : "Not Found"
        })
    }

    if (loading) {
        return <Box>
            <Crumbs crumbs={crumbs} />
            <Box pt={1}>
                <Paper>
                    <Box p={2}>
                        <Typography variant={"h6"}>Loading</Typography>

                    </Box>
                    <Box p={2}>
                        <Skeleton variant="rectangular" width={410} height={60} />
                    </Box>
                    <Box p={2}>
                        <Skeleton variant="rectangular" width={410} height={20} />
                    </Box>
                </Paper>
            </Box>
        </Box>
    }

    if (!loading && !venue) {
        return <Box>
            <Crumbs crumbs={crumbs} />
            <Typography variant={'h5'}>Venue Not Found</Typography>
        </Box>
    }

    return (
        <Box>
            <Crumbs crumbs={crumbs} />
            {venue && <Paper>
                <Box m={2} py={2}>
                    {venue.images && <Box>as<img sx={{ height: 140 }} src={venue.images[0].url} title={venue.name} /></Box>}
                    <Typography variant="h5">
                        {venue.name}
                    </Typography>
                    {venue.location && <Typography component="div" variant={"overline"}>{venue.location}</Typography>}

                    {venue.website && <Box mt={1}>
                        <Button href={venue.website} target="_blank" size={"small"} startIcon={<PublicIcon fontSize="small" color="primary" sx={{ mr: 0.5 }} />}>
                            {venue.website.toLowerCase().replace("https://","").replace("http://","").replace("www.","")}
                        </Button>
                    </Box>}

                    {venue.insta && <Box mt={1}>
                        <Button href={"https://instagram.com/" + venue.insta} target="_blank" size={"small"} startIcon={<InstagramIcon fontSize="small" color="primary" sx={{ mr: 0.5 }} />}>
                            {venue.insta}
                        </Button>
                    </Box>}

                    <VenueMeta v={venue} />

                    <Box mt={3}>
                        <Typography variant={"overline"}>Upcoming Shows</Typography>
                    </Box>
                    {events.map(e => <Box mb={2} key={e.date}>
                        <Typography variant={"body1"}>{dateToHumanDateStr(new Date(e.date + " 12:00:00"))}</Typography>
                        <table>
                            <tbody>
                                {toSlots(e.event_artists, e.event_instructors).map((ea,i) =>
                                    <tr key={i}>
                                        <td style={{
                                            textAlign: "right",
                                            verticalAlign: "top",
                                            padding: "0 6px 0 0"
                                        }}>{display24HourTime(ea.time)}</td>
                                        <td style={{padding: 0}}>{ea?.artist?.danceable ?
                                            <Link href={"/artist/" + ea.artist.artistKey}><strong>{ea.title}</strong></Link>
                                            : ea.title}
                                            {ea?.artist?.tag && <span> <i>{ea?.artist?.tag}</i> </span>}
                                            {ea?.artist?.venmo &&
                                                <TipBox artist={ea.artist} />}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        </Box>
                        )}
                </Box>
            </Paper>}
        </Box>
    );
}

export default VenuePage;